module.exports = __webpack_public_path__ + "static/img/dnbk.bb6a38a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/content/dnbk.png
// module id = IsIR
// module chunks = 15